module.exports = __webpack_public_path__ + "static/media/ga.29f203bb.svg";